import React, { memo, useEffect, useRef, useState } from "react";

const CountDownTimer = ({
                            countDownTimer = 0,
                            totalResult = 0,
                            drawCode = "",
                            onLastTenSecond,
                            onCancelBetting,
                        }) => {
    const [count, setCount] = useState(countDownTimer);

    const intervalRef = useRef(null);
    const prevDrawCodeRef = useRef(drawCode);
    const prevCountRef = useRef(count);

    // Reset when new draw arrives
    useEffect(() => {
        if (prevDrawCodeRef.current !== drawCode) {
            prevDrawCodeRef.current = drawCode;
            setCount(countDownTimer);
        }
    }, [drawCode, countDownTimer]);

    // Start timer
    useEffect(() => {
        if (intervalRef.current) clearInterval(intervalRef.current);

        intervalRef.current = setInterval(() => {
            setCount((prev) => (prev > 0 ? prev - 1 : 0));
        }, 1000);

        return () => clearInterval(intervalRef.current);
    }, [drawCode]);

    // Handle side effects safely
    useEffect(() => {
        const prev = prevCountRef.current;

        if (prev !== count) {
            if (prev <= 11 && prev > 0 && onLastTenSecond) {
                onLastTenSecond(count);
            }

            if (prev === 10 && onCancelBetting) {
                onCancelBetting();
            }
        }

        prevCountRef.current = count;
    }, [count, onLastTenSecond, onCancelBetting]);

    const displayValue = totalResult > 0 ? totalResult : count;

    return (
        <div
            className="bg-danger d-flex justify-content-center align-items-center count-down w-100"
            style={{ position: "absolute", bottom: 0, height: "15%" }}
        >
            {displayValue}
        </div>
    );
};

export default memo(CountDownTimer);